/* ═══════════════════════════════════════════════════════════════════════════════════════════════
   assets/asf-look-viewer-3.js ── LOOKS 写真の全画面ビューワー（2026-08-05 / 世代 -41）
   ── 世代 -2（PC でも開く）からの **世代替え**。-2 / -1 はファイルとして残置（--nodelete 運用）。
   ------------------------------------------------------------------------------------------------
   ★ -3 で変わったのは「PC でビューワーを開くか」の 2 定数だけ ★ 他は -2 と 1 バイト差もない。
     クライアント裁定（2026-08-05・逐語要旨）「**PC 版の LOOKS の拡大機能はいらない**」。
     -35 の設計どおり「1 行で撤回可」を実際に使う世代。SP（タッチ環境）の挙動は完全に不変。
       OPEN_ON_PC   = false … PC（hover:hover かつ pointer:fine）ではビューワーを開かない。
       PC_CLICK_INERT = true … さらに capture 段で click を止め、PC の写真クリックを
                               **完全に無反応**にする（＝ 依頼書の「何も起きない」）。
     ★ PC_CLICK_INERT を置いた理由（判断記録・要確認事項）★
       OPEN_ON_PC を false にするだけだと click は素通しになり、asf-index.js の bindAdvance
       （2026-07-26 のクライアント裁定「PC: 写真クリック = 次へ送り」）が復活して
       **写真が 1 枚送られる** ＝ 「何も起きない」にはならない。本走の依頼は
       「PC 1280 で LOOKS 写真クリック → 何も起きない」と明示されているので、
       capture 段で stopPropagation して次送りごと止める方を採った。
       ・PC の送りはステージ左右の送り矢印 .look-nav（#lookCarousel の **外**・兄弟要素）が
         引き続き担当するので、PC から送る手段が無くなるわけではない（矢印は 1 バイトも触っていない）。
       ・2026-07-26 の「クリック = 次送り」へ戻したい場合は **PC_CLICK_INERT を false にする 1 行**だけ。
     ★ 旧ライトボックス（.look-lightbox）へは戻さない ★ asf-index.js の LOOK→ライトボックス経路は
       2026-07-26 に撤去済みで、本ファイルは 1 バイトも触っていない。よって PC の LOOKS 拡大経路は全廃。
     ★ 差し戻し ★ layout の 〈script〉 1 行を asf-look-viewer-2.js へ戻せば PC でも開く姿へ完全復帰する。
   ------------------------------------------------------------------------------------------------
   ★ 世代替えの理由 = クライアント再裁定（逐語要旨）★
     「LOOKS ビューワーを Klim トップページの文法＝**縦スクロールで全写真が連続**する形へ。
       タップ→全画面(cover)は維持。**横フリック捲りは廃止**。
       scroll-snap（1 画面 1 枚でカチッと止まる）を第一候補とするが、Klim トップの実挙動
       （スナップ有無）は依頼主も実測値を持っていないので、**両案を実装比較して光学判断し記録**すること。」

     ＝ -1 の骨格（3 セルのストリップを translate3d で横に運ぶ・hermite トゥイーン・
        JS 軸ロック・1 フリック 1 送り）は **丸ごと役目を終えた**。ジェスチャの意味論が
        「捲る（離散・1 枚ずつ・自前の物理）」から「流す（連続・ネイティブスクロール）」へ
        反転しており、-1 に条件分岐を足して両立させると
          ・touch-action:none（＝ネイティブ縦パンを殺す）と「縦スクロールが本義」が正面衝突
          ・自前トゥイーンとブラウザの慣性スクロールが同じ面の上で二重に走る
        の 2 点で必ず壊れる。よって **新ファイルで世代替え**し、-1 は 1 バイトも触らない。

   ★ 前世代（-1）から引き継いだもの / 捨てたもの ★
     引き継ぎ  … 1 行目の data-font ガード / 起動経路（#lookCarousel の click を capture で奪う）/
                  100dvw × 100dvh・object-fit:cover / ✕ 44px 右上・セーフエリア・difference /
                  Esc で閉じる / 背景タップ・下フリックでは閉じない / body.look-viewer-open で背面停止 /
                  GA look_photo_view のイベント名・パラメータ・連続重複抑制 /
                  #lookCarouselCounter を「現在の写真番号」の唯一の真実源にする /
                  クローン（aria-hidden="true"）を除いた素のスライドだけを数える。
     破棄      … 3 セルのストリップと slot 回転 / hermite トゥイーンと rAF ループ /
                  pointerdown-move-up の軸ロック（DRAG_SLOP / MIN_DPOS / MIN_VEL / S_BASE …）/
                  ループ（末尾→先頭のラップ。縦の連続スクロールに終端が無いのは不自然なので
                  **有限**にした。先頭で上・末尾で下はゴムで止まる）/
                  PC の「写真クリックで次送り」（縦スクロールではホイールが自然な送りであり、
                  クリック送りは指/カーソルのドラッグ選択と競合するだけなので撤去。
                  PC の送りはホイール + ↑↓ / PageUp・PageDown / Home・End が担当する）/
                  ← → の横方向キー（縦が本義になったため ↑↓ の別名として残すのみ）。

   ★ 何をするか（それ以外は何もしない）★
     ① VISUAL の LOOK カルーセル（#lookCarousel）の写真をタップ/クリック → 全画面ビューワーを開く。
        **タップされた写真が先頭に来る**（= その写真のセルにスクロール位置を合わせて開く）。
     ② 全写真（枚数は DOM から動的に数える。13 でも 15 でもコードは不変）を
        1 本の縦スクロールコンテナに 100dvw × 100dvh・object-fit:cover で連結し、
        **ネイティブの縦スクロール**で連続して見せる。
     ③ ✕（44px・右上）/ Esc で閉じる。
     背景タップでは閉じない / 下フリックでも閉じない（誤操作防止・現行裁定どおり ✕ と Esc のみ）。

   ═══ ★ A/B 2 案の判断記録（scroll-snap の採否）★ ═══════════════════════════════════════════
     A 案 … scroll-snap-type: y mandatory + 各セル scroll-snap-align: start（1 画面 1 枚で停止）
     B 案 … スナップ無し（自由な連続スクロール）

     ★ 採用 = A 案 ★（下の SNAP = true。B 案へ切り替えるのは **この 1 行を false にするだけ**。
       CSS 側は .look-viewer__scroller.is-snap にだけスナップ規則を持たせてあるので、
       false にすると is-snap が付かず、CSS を 1 バイトも触らずに B 案になる。）

     ── 判断の根拠（実測に基づく所見）────────────────────────────────────────────────
     ① 指を離した位置の予測可能性 … 本ビューワーのセルは **ビューポートと寸分同じ高さ**
        （100dvh・cover）である。この寸法では B 案の停止位置は「2 枚の写真が上下に分かれ、
        画面のどこかに硬い水平の継ぎ目が 1 本走る」状態が **既定の結果**になる。
        ★ 実測（ローカル静的ハーネス・Chromium・390×844・セル高 844px・15 枚。
          スナップ点から所定量だけスクロールして離し、1.2s 後の停止位置を測った）★
            送り量 0.40 セル … A 案 → +0.000 セル（＝ 直前の写真へ確定的に戻る）
                               B 案 → +0.399 セル（＝ 離した位置にそのまま留まる）
            送り量 0.62 セル … A 案 → +1.000 セル（＝ 次の写真へ確定的に着く）
                               B 案 → +0.620 セル（＝ 離した位置にそのまま留まる）
          B 案は「離した場所がそのまま停止位置」＝ 2 枚が 40:60 で分割された絵が安定して残る。
          A 案は必ず 0 か 1 に丸まる。「どこで止まるか読めない」のは B 案側で、
          写真ビューワーとしてはこれが最も強い減点になる。
        ★ この実測の限界（正直に記録）★ 計測は **デスクトップ Chromium のホイール入力**であり、
          iOS WebKit の指の慣性そのものではない。ただし比較しているのは「離した後にどこへ
          落ち着くか」という **スナップの有無に固有の性質**であり、これは入力デバイスに
          依らず同じ向きに効く（慣性の長さは変わっても、着地が丸まるか否かは変わらない）。
          実機 iOS での最終確認は親の WIP テーマ検証に委ねる。
     ② 写真の切り替わりの読み取りやすさ … cover で全画面を埋める写真は、上下に分割されると
        「1 枚の写真の一部」なのか「2 枚の写真」なのかが一瞬判別できない（LOOK は同じモデル・
        同じ location の連作なので特に紛れる）。A 案は常に 1 枚だけを見せるので、
        「いま何番の写真を見ているか」が視覚だけで確定する。
        ✕ の当たり判定（右上・セーフエリア）も「1 枚の写真の右上」に一致し続ける。
     ③ 慣性の効き方 … A 案の mandatory は「セル高 = ビューポート高」という最も安全な形
        （どの位置からもスナップ点まで 1 セル未満）で使っており、スナップ点が遠すぎて
        スクロールが檻に入る（scroll-trapping）現象は原理的に起きない。
        速いフリックはブラウザが慣性を解決した **後** に最寄りへ吸い付くので、
        「一気に何枚も送る」自由は残ったまま、着地だけが必ず 1 枚に整う。
        （-1 の「過速フリックでも 1 枚ずつ」という制約は横捲り固有の裁定であり、
          縦の連続スクロールでは「速く払えば速く進む」ほうが Klim の文法に一致するため持ち込まない。）
     ④ Klim トップとの差の説明 … Klim トップの写真は 100vh の cover ではなく、
        高さの異なる写真が段組で流れる **編集面**なので、半端な停止位置が自然に見える。
        本件は裁定①（「iPhone 16 Plus でも縦幅がはみ出すほど」＝ 100dvh cover）が先に確定して
        いるため、同じ「連続スクロール」でも寸法条件が違う。寸法が 1 画面 1 枚に固定された以上、
        停止位置も 1 画面 1 枚に揃えるのが整合する ＝ A 案。
     ⑤ GA の副次的な理由 … 発火条件「50% 以上見えているセルが変わった瞬間」は、
        B 案だと「50% 付近で止まった」状態が安定して残り得るため、わずかな指の揺れで
        50% 境界を何度も跨いで往復発火する余地がある。A 案は停止位置が 0% / 100% に
        確定するので、境界に居座る状態が存在しない（発火が構造的に安定する）。
     ── 差し戻し（B 案を見たくなったら）── SNAP = false の 1 行のみ。CSS も Liquid も不変。
   ═══════════════════════════════════════════════════════════════════════════════════════════

   ★ GA（look_photo_view）の意味論の維持方法 ★
     既存の意味論は「**表示中の写真が切り替わった 1 点**で送る・連続重複は抑制・
     見えていない間は送らない」（asf-index.js の trackPhotoView / -1 の commit と同一）。
     -1 では「横捲りの着地」がその 1 点だったが、縦の連続スクロールには着地イベントが無い。
     そこで **IntersectionObserver（root = スクローラ / threshold 0.5）**で
     「50% 以上見えているセルが変わった瞬間」を 1 点に採る。
       ・セル高 = ルート高なので、50% 以上見えるセルは **常に高々 1 枚**（＝ 1 点が一意に定まる）。
       ・1 回のコールバックで ratio ≥ 0.5 のエントリが複数来た場合（ちょうど境界）は
         ratio 最大のものを採る。0.5 未満のエントリしか来ない回（下抜けの報告のみ）は何もしない。
       ・送信は window.asfTrack('look_photo_view', { photo_number:'01'〜, collection:'OUT OF CLUB' })
         ＝ asf-index.js / -1 と **完全に同じ形**（イベント名・引数の 2 パラメータ・pad2 の 2 桁）。
     ★ 重複発火の扱い（明示的な決め）★
       (a) 開いた瞬間は送らない … その番号はカルーセル側が既に送っている（-1 と同じ二重計上の抑止）。
           open() で gaLast を開始番号に先置きすることで、最初の IO コールバックを黙らせる。
       (b) 連続重複の抑制のみ行う（gaLast と同じ番号なら送らない）。
           ＝ 「01 → 02 → 01」と戻ってきたときの 2 度目の 01 は **送る**。
           これは asf-index.js の trackPhotoView（goTo 経由の往復も同様に送る）および -1 と
           同一の規則で、「表示中の写真が切り替わった 1 点」という意味論そのもの。
           セッション単位のユニーク化はここでは行わない（GA4 側の集計の仕事）。
       (c) 50% 境界をまたがない揺れ（同じセルの中での上下動）では発火しない。
           IO の閾値を跨がないためコールバック自体が来ない ＝ 構造的に静か。
       (d) 高速フリックで飛び越えた中間のセルは送らない（IO は閾値の跨ぎを取りこぼす）。
           「見ていない写真を見たことにしない」ので、意味論としてはむしろ正しい側に倒れる。
       (e) 閉じている間は送らない … openFlag ガード（display:none で ratio が 0 になる
           クローズ時のコールバックも、このガードで完全に沈黙する）。
       (f) ★ 複数枚ジャンプ（Home / End）は「即時スクロール」にする ★
           scrollTo({behavior:'smooth'}) は通り道のセルを 1 枚ずつ実際に画面へ通すため、
           IO が中間セルすべてで 50% 跨ぎを拾い、**1 打で 11 件**（ローカル計測値）の
           look_photo_view が飛ぶ。指の高速フリックでは IO が跨ぎを取りこぼすので
           同じ水増しは起きない ＝ プログラム的 smooth だけが特異点。よって
           「隣 1 枚 = smooth ／ 2 枚以上 = 即時」に分け、後者は最終状態のみ 1 件送る（goTo 参照）。

   ★ 軸の整理（-1 の touch-action:none + JS 軸ロックの見直し）★
     -1 は「ブラウザの自動パン判定を消し、軸の確定を 100% JS で行う」処方だった。
     -2 は **縦パンがブラウザの仕事そのもの**なので、この処方を逆向きに書き換える。
       ・.look-viewer / .look-viewer__scroller に **touch-action: pan-y** を敷く。
         pan-y は「縦パンだけ許可」＝ 縦スクロールはネイティブの慣性で自然に効き、
         横パン・ピンチズーム・ダブルタップズームは発生しない（写真面での誤ズームを防ぐ）。
       ・JS の pointerdown / pointermove / pointerup は **1 個も登録しない**。
         ＝ 自前トゥイーンとブラウザ慣性の二重駆動が原理的に起きない。
       ・overscroll-behavior: contain（スクロール連鎖 / 引っ張り更新の遮断）は
         .player-drawer__scroll（既存の縦スクローラ）と同じ処方に揃える。
     ★ ビュー切替の横フリック（サイト本体の 5 ビュー切替）が奪われないことの根拠 ★
       (1) **開いていないとき** … .look-viewer は display:none（.is-open が無い）なので
           ヒットテストの対象に一度もならない ＝ FLICK VIEW NAV の excluded() が辿る
           e.target の祖先鎖に .look-viewer が現れることはあり得ない。
           さらに初回オープンまで DOM ノード自体が存在しない。touch-action:pan-y も
           「その要素に触れた指」にしか効かないので、本体の面には一切影響しない。
       (2) **開いているとき** … asf-index.js の EXCLUDE には既に '.look-viewer' が入っている
           （世代 -35 で追加済み・本走では asf-index.js に 1 バイトも触らない）。
           touchstart の e.target がビューワー内なら excluded() が true を返し、
           FLICK VIEW NAV は tracking=false で即降りる ＝ ビューワー上の横払いが
           隣のタブへ飛ぶことはない。加えて body.look-viewer-open{overflow:hidden} で
           背面は停止したまま。
       (3) スクローラは overflow-y:auto / overflow-x:hidden なので、excluded() の「保険」節
           （祖先に overflow-x:auto|scroll の実容量があれば除外）には掛からないが、
           (2) の明示除外が効いているので結論は変わらない（＝ asf-index.js の変更は不要）。

   ★ 差し戻し手順 ★
     layout/theme.liquid の
       <script src="{{ 'asf-look-viewer-2.js' | asset_url }}" defer></script>
     を
       <script src="{{ 'asf-look-viewer-1.js' | asset_url }}" defer></script>
     へ戻す **1 行のみ**で、横フリック捲りの世代 -1 に完全に戻る。
     （CSS は .look-viewer__scroller という新しい名前空間に足すだけで、-35 の M1〜M4 のうち
       -2 と矛盾する 2 プロパティ（.look-viewer の touch-action と .look-viewer__cell の
       position）を後追いで上書きする形にしてあるが、-1 は自分でインライン transform を
       書くので上書きの影響を受けない。厳密に戻したい場合は追記ブロックの削除も併せて行う。）
     ★ -1 と -2 を同時に読み込んではならない ★ theme.liquid の script は **1 行の置換**であって
       併記ではない。万一併記された場合に「2 つのビューワーが同時に開く」という診断困難な壊れ方を
       させないため、-2 は冒頭で window.ASF_LOOK_VIEWER の存在を見て撤退する
       （＝ 併記時は -1 の挙動がそのまま残る ＝「横フリックのままだ」と一目で分かる失敗の仕方になる）。

   ★ 触っていないもの ★ 音声層 / SHOP 3D 軌道 / 商品・bio オーバーレイ / ルーター /
     共有ビューア（asfViewer）/ Liquid のマークアップ（ビューワーの DOM は本ファイルが生成する）/
     assets/asf-index.js（-35 で入れた 2 行がそのまま -2 にも効くので追加の触りはゼロ）/
     assets/asf-look-viewer-1.js（読むだけ）。
   ═══════════════════════════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var ROOT = document.documentElement;
  if (ROOT.getAttribute('data-font') !== 'soehne') { return; }   /* 既定 / neuedin は即撤退 */

  /* ★ 併記事故ガード ★（上の「差し戻し手順」の最終段落を参照）
     -1 が同一ページに載っていたら -2 は何もしない。-1 は自分の IIFE の末尾で
     window.ASF_LOOK_VIEWER を立てるので、defer の実行順（theme.liquid の記述順）で
     -1 が先に完走していればここで確実に検出できる。 */
  if (window.ASF_LOOK_VIEWER) { return; }

  /* ── A/B スイッチ（判断記録は冒頭コメントの「A/B 2 案の判断記録」節）─────────────
     true  = A 案: scroll-snap-type:y mandatory（1 画面 1 枚でカチッと止まる）★採用★
     false = B 案: スナップ無し（自由な連続スクロール）
     ★ 切り替えはこの 1 行だけ ★ CSS は .look-viewer__scroller.is-snap にのみスナップ規則を
       持たせてあるので、false にすると is-snap が付かず自動的に B 案になる。 */
  var SNAP = true;
  /* var SNAP = false;   ← B 案（スナップ無し）を見るときは上を消してこの行を生かす */

  /* ── 定数 ──────────────────────────────────────────────────────────────────── */
  var CLICK_SLOP = 8;          /* これを超えて動いたら「タップ」ではなくドラッグ扱い（-1 と同値） */
  var GA_RATIO = 0.5;          /* 「50% 以上見えているセル」= 表示中の写真（裁定どおり） */
  var PRELOAD = 2;             /* 開いた瞬間に src を入れておく前後のセル数（黒抜け防止） */
  var LAZY_MARGIN = '200% 0px';/* 遅延 src の先読み範囲（上下 2 画面ぶん） */
  var GA_COLLECTION = 'OUT OF CLUB';   /* asf-index.js の trackPhotoView と同値 */

  var mqMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function motionOff(){ return !!(mqMotion && mqMotion.matches); }
  var mqFine = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : null;
  function finePointer(){ return !!(mqFine && mqFine.matches); }
  function pad2(n){ return (n < 10 ? '0' : '') + n; }
  function clamp(v, lo, hi){ return v < lo ? lo : (v > hi ? hi : v); }

  /* ★ PC でもタップ（クリック）で開くか ★ -1 / -2 の既定は true だったが、
     2026-08-05 のクライアント裁定「PC 版の LOOKS の拡大機能はいらない」で **false** へ。
     SP（タッチ環境）は finePointer() が偽なので、この 2 定数はどちらも一切効かない ＝ 完全不変。
     PC のビューワー内操作（ホイール / ↑↓ / PageUp・PageDown / Home・End / Esc）は
     開く経路が無くなるだけでコードは残置する（差し戻し時にそのまま生きる）。 */
  var OPEN_ON_PC = false;

  /* ★ PC のクリックを「何も起きない」にするか ★ 上を false にしただけでは click が素通しになり、
     asf-index.js の bindAdvance（PC = 次送り）が復活して写真が 1 枚進む。
     本走の依頼は「PC で LOOKS 写真をクリック → 何も起きない」なので capture 段で止める。
     ★ 2026-07-26 の「PC: 写真クリック = 次送り」へ戻すときは、この 1 行を false にするだけ ★
     ★ OPEN_ON_PC が true のときは無視される（開く方が優先。定数の意味の衝突を避ける）★ */
  var PC_CLICK_INERT = true;

  var carousel = document.getElementById('lookCarousel');
  if (!carousel) { return; }                     /* index 以外のテンプレートでは何もしない */

  /* ── 写真の一覧（data-full = 1078×1600 の large。Liquid の既存属性をそのまま読む）──
     ★ 枚数はハードコードしない ★ DOM を数えるだけなので 13 枚でも 15 枚でもコードは不変。
     ★ クローンを除外する ★ asf-index.js の initCarousel はループ用に先頭/末尾へ
        aria-hidden="true" の複製を挿入する。本ファイルは defer の実行順で asf-index.js より
        **前** に走るが、entries は open() 時に遅延取得するのでどちらの順序でも
        「素のスライドだけ」が正しく採れる。 */
  var entries = null;
  function getEntries(){
    if (entries) { return entries; }
    var list = carousel.querySelectorAll('.np-carousel__slide:not([aria-hidden="true"])');
    var out = [], i, s, full, im;
    for (i = 0; i < list.length; i++){
      s = list[i];
      full = s.getAttribute('data-full');
      if (!full) { continue; }
      im = s.querySelector('img');
      out.push({ full: full, alt: (im && im.getAttribute('alt')) || '' });
    }
    entries = out.length ? out : null;
    return entries;
  }

  /* 現在の写真番号 — カウンター #lookCarouselCounter（pad2(pos+1)）が唯一の真実源。
     クローンをタップした場合も含めて常に正しい（DOM 位置から逆算しない）。 */
  function currentIdx(N){
    var c = document.getElementById('lookCarouselCounter');
    var n = c ? parseInt(String(c.textContent || '').replace(/[^0-9]/g, ''), 10) : NaN;
    if (isFinite(n) && n >= 1 && n <= N) { return n - 1; }
    return 0;
  }

  /* ── ビューワーの DOM（初回オープン時に 1 度だけ生成）───────────────────────
     Liquid を 1 バイトも変えずに済む＝「既定モードでは DOM が存在しない」という
     最も強い形の不変証明になる（-1 から踏襲）。 */
  var host = null, scroller = null, closeBtn = null;
  var cells = [], imgs = [];
  var N = 0, curIdx = 0;
  var openFlag = false, lastFocus = null;
  var ioGA = null, ioLazy = null;

  function build(){
    var list = getEntries();
    N = list.length;

    host = document.createElement('div');
    host.className = 'look-viewer';
    host.id = 'lookViewer';
    host.setAttribute('role', 'dialog');
    host.setAttribute('aria-modal', 'true');
    host.setAttribute('aria-hidden', 'true');
    host.setAttribute('aria-label', 'A.S.F. Look photos — full screen');

    /* ★ ネイティブの縦スクローラ ★ 位置・慣性・ゴム・スナップの一切をブラウザに任せる。
       tabindex="-1" は「キーボードの既定スクロール（Space / PageDown 等）の受け皿」ではなく、
       将来 focus() したくなったときのための保険（本走では明示キー処理を持つので使わない）。 */
    scroller = document.createElement('div');
    scroller.className = 'look-viewer__scroller' + (SNAP ? ' is-snap' : '');
    scroller.id = 'lookViewerScroller';
    scroller.setAttribute('tabindex', '-1');

    var i, cell, im;
    for (i = 0; i < N; i++){
      cell = document.createElement('figure');
      cell.className = 'look-viewer__cell';
      cell.setAttribute('data-i', String(i));
      im = document.createElement('img');
      im.className = 'look-viewer__img';
      im.setAttribute('decoding', 'async');
      im.setAttribute('draggable', 'false');
      /* ★ alt は全セルに実物を入れる ★ -1 は 3 セルの使い回しだったため現在セル以外を
         空 alt にしていたが、-2 は 1 写真 = 1 ノードの素直な列なので、
         それぞれの写真の alt をそのまま持たせるのが正しい（AT が列として読める）。 */
      im.alt = list[i].alt;
      cell.appendChild(im);
      scroller.appendChild(cell);
      cells.push(cell);
      imgs.push(im);
    }

    closeBtn = document.createElement('button');
    closeBtn.className = 'look-viewer__close';
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = '&times;';

    host.appendChild(scroller);
    /* ✕ は **スクローラの外**（host の直下）に置く ＝ 写真と一緒にスクロールで流れ去らない。
       -35 の M3（position:absolute・右上・セーフエリア・difference）がそのまま効く。 */
    host.appendChild(closeBtn);
    document.body.appendChild(host);

    closeBtn.addEventListener('click', function(e){ e.stopPropagation(); close(); });

    initObservers();
  }

  /* ── 遅延 src ────────────────────────────────────────────────────────────────
     ★ 一度入れた src は二度と外さない ★ 戻りスクロールで白抜け / 再デコードが起きないため。
     写真は 1078×1600 の large が 13〜15 枚だが、ビューワーを開いた時点で
     「全部見るつもり」の操作なので、先読みの積み増しは意味論と一致する。 */
  function ensureSrc(i){
    if (i < 0 || i >= N) { return; }
    var im = imgs[i];
    if (!im || im.getAttribute('src')) { return; }
    im.src = getEntries()[i].full;
  }

  /* ── GA（look_photo_view）──────────────────────────────────────────────────
     イベント名・パラメータは asf-index.js の trackPhotoView / -1 の track と完全同一。 */
  var gaLast = null;
  function track(i){
    var n = pad2(clamp(i, 0, N - 1) + 1);
    if (n === gaLast) { return; }                /* 連続重複の抑制（-1 と同一規則） */
    gaLast = n;
    try{
      if (typeof window.asfTrack === 'function'){
        window.asfTrack('look_photo_view', { photo_number: n, collection: GA_COLLECTION });
      }
    }catch(e){}
  }

  function initObservers(){
    if (!window.IntersectionObserver) {
      /* IO 非対応環境 … 全 src を即入れ、GA は「開いた番号」だけ（カルーセル側が既送のため実質無送信）。
         スクロール自体はネイティブなので機能は完全に保たれる（劣化するのは計測と遅延読込だけ）。 */
      for (var k = 0; k < N; k++){ ensureSrc(k); }
      return;
    }

    /* ① GA 用 — 「50% 以上見えているセルが変わった瞬間」を 1 点に採る。 */
    ioGA = new IntersectionObserver(function(list){
      if (!openFlag) { return; }                 /* 閉じている間は 1 件も送らない（(e)） */
      var best = -1, bestR = -1, j, en, i2;
      for (j = 0; j < list.length; j++){
        en = list[j];
        if (en.intersectionRatio < GA_RATIO) { continue; }
        i2 = parseInt(en.target.getAttribute('data-i'), 10);
        if (!isFinite(i2)) { continue; }
        if (en.intersectionRatio > bestR){ bestR = en.intersectionRatio; best = i2; }
      }
      if (best < 0) { return; }                  /* 下抜けの報告だけの回 = 何もしない */
      curIdx = best;                             /* リサイズ時の位置保存にも使う */
      track(best);
    }, { root: scroller, threshold: GA_RATIO });

    /* ② 遅延 src 用 — 前後 2 画面ぶん先まで src を入れる。 */
    ioLazy = new IntersectionObserver(function(list){
      for (var j = 0; j < list.length; j++){
        if (!list[j].isIntersecting) { continue; }
        var i2 = parseInt(list[j].target.getAttribute('data-i'), 10);
        if (isFinite(i2)) { ensureSrc(i2); }
      }
    }, { root: scroller, rootMargin: LAZY_MARGIN, threshold: 0 });

    for (var i = 0; i < N; i++){ ioGA.observe(cells[i]); ioLazy.observe(cells[i]); }
  }

  /* ── スクロール位置 ────────────────────────────────────────────────────────── */
  function cellH(){ return scroller.clientHeight || window.innerHeight || 1; }

  /* 指定セルへ即時に位置を合わせる（オープン時 / リサイズ時）。
     ★ mandatory スナップを一時的に外す理由 ★ 「レイアウトが変わった直後にスナップを
       解決し直す」実装（Blink / WebKit）では、代入した scrollTop が再スナップで
       先頭（index 0）へ引き戻されることがある。none にしてから代入 → 反映を強制 →
       次フレームで復帰、の順にすると、復帰時点で既に **ちょうどスナップ点の上**に
       居るので引き戻しが起こり得ない。B 案（SNAP=false）では none の付け外しは無害な no-op。 */
  var snapRestoreRaf = null;
  function jumpTo(i){
    if (!scroller) { return; }
    var H = cellH();                             /* clientHeight の読取り = レイアウト確定の強制 */
    scroller.style.scrollSnapType = 'none';
    scroller.scrollTop = i * H;
    if (snapRestoreRaf !== null){ cancelAnimationFrame(snapRestoreRaf); }
    snapRestoreRaf = requestAnimationFrame(function(){
      snapRestoreRaf = null;
      /* 位置が取れていない（display 直後の 0 高さ等）場合はもう一度だけ入れ直す */
      var H2 = cellH();
      if (Math.abs(scroller.scrollTop - i * H2) > 1){ scroller.scrollTop = i * H2; }
      scroller.style.scrollSnapType = '';        /* CSS（.is-snap の有無）へ戻す */
    });
  }

  /* キーボードの送り。スナップ点ちょうどへ運ぶだけなので snap を外す必要はない。
     ★ 滑らかに送るのは「隣の 1 枚」だけ ★（実測に基づく設計）
       scrollTo({behavior:'smooth'}) は **通り道のセルを 1 枚ずつ実際に画面に通す**ので、
       Home / End のような複数枚ジャンプを smooth でやると IntersectionObserver が
       途中のセルすべてで 50% 跨ぎを検出し、**1 回のキー操作で look_photo_view が
       10 件以上飛ぶ**（ローカル計測: End キー 1 打で 11 件を観測）。
       指の高速フリックでは IO が閾値跨ぎを取りこぼすので同じ現象は起きない ＝
       プログラム的な smooth スクロールだけが GA を水増しする特異点になる。
       よって「隣 1 枚 = smooth（動きで方向が読める）／ 2 枚以上 = 即時（中間を通さない）」に分ける。
       即時なら IO は最終状態しか報告しないので発火は 1 件、意味論どおりになる。 */
  function goTo(i){
    if (!scroller) { return; }
    var t = clamp(i, 0, N - 1);
    var from = idxFromScroll();
    curIdx = t;
    var top = t * cellH();
    if (motionOff() || !scroller.scrollTo || Math.abs(t - from) > 1){ scroller.scrollTop = top; return; }
    try{ scroller.scrollTo({ top: top, behavior: 'smooth' }); }
    catch(e){ scroller.scrollTop = top; }
  }
  /* いま画面を占めているセル（IO を待たずに即答が要る場面用） */
  function idxFromScroll(){
    return clamp(Math.round(scroller.scrollTop / cellH()), 0, N - 1);
  }

  /* ── 開閉 ──────────────────────────────────────────────────────────────────── */
  function open(i){
    var list = getEntries();
    if (!list || openFlag) { return; }
    if (!host) { build(); }
    N = list.length;
    curIdx = clamp(i, 0, N - 1);                 /* ★ ループ廃止 ★ -1 の mod() → clamp() */
    gaLast = pad2(curIdx + 1);                   /* 開いた番号はカルーセル側が既に送っている（(a)） */
    lastFocus = document.activeElement;
    openFlag = true;
    document.body.classList.add('look-viewer-open');
    host.classList.add('is-open');               /* ★ 位置合わせの前に display:block にする ★ */
    host.setAttribute('aria-hidden', 'false');
    var k;
    for (k = curIdx - PRELOAD; k <= curIdx + PRELOAD; k++){ ensureSrc(k); }
    jumpTo(curIdx);
    /* preventScroll … ✕ はスクローラの外なので理屈上は動かないが、
       ブラウザが「フォーカス可視化のための最小スクロール」を走らせる余地を潰しておく。 */
    try{ closeBtn.focus({ preventScroll: true }); }catch(e){ try{ closeBtn.focus(); }catch(e2){} }
  }
  function close(){
    if (!openFlag) { return; }
    openFlag = false;
    if (snapRestoreRaf !== null){ cancelAnimationFrame(snapRestoreRaf); snapRestoreRaf = null; }
    if (scroller){ scroller.style.scrollSnapType = ''; }
    host.classList.remove('is-open');
    host.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('look-viewer-open');
    try{ if (lastFocus && lastFocus.focus && document.contains(lastFocus)) { lastFocus.focus(); } }catch(e){}
    lastFocus = null;
  }

  /* ── 起動（カルーセルのタップ / クリック）──────────────────────────────────
     capture 段で受けて stopPropagation する ＝ asf-index.js の bindAdvance（PC 次送り）へ
     落とさない。asf-index.js には触らずに経路を差し替えられる唯一の位置（-1 から逐語で踏襲）。 */
  var downX = 0, downY = 0, downMoved = 0;
  carousel.addEventListener('pointerdown', function(e){
    downX = e.clientX; downY = e.clientY; downMoved = 0;
  }, { passive: true });
  carousel.addEventListener('pointerup', function(e){
    downMoved = Math.sqrt((e.clientX - downX) * (e.clientX - downX) + (e.clientY - downY) * (e.clientY - downY));
  }, { passive: true });
  carousel.addEventListener('click', function(e){
    if (openFlag) { return; }
    if (!OPEN_ON_PC && finePointer()) {
      /* -41: PC は開かない。PC_CLICK_INERT なら次送り（asf-index.js bindAdvance）ごと止めて
         「何も起きない」にする。ドラッグ終端のクリックも同じ扱いでよい（どちらも無反応）。
         ★ 送り矢印 .look-nav は #lookCarousel の外（兄弟）なので、この stopPropagation は届かない ★ */
      if (PC_CLICK_INERT) { e.stopPropagation(); }
      return;
    }
    var m = downMoved; downMoved = 0;
    if (m > CLICK_SLOP) { return; }              /* ドラッグ終端のクリックは素通し（既存ガードに委ねる） */
    var list = getEntries();
    if (!list) { return; }
    e.stopPropagation();
    open(currentIdx(list.length));               /* ★ タップされた写真が先頭に来る ★ */
  }, true);

  /* ── キーボード ─────────────────────────────────────────────────────────────
     ✕ にフォーカスが載っている（＝スクローラの外）ので、ブラウザ既定のキースクロールは
     このスクローラには届かない。よって送りは明示的に処理する。
     ← → は縦が本義になった今も「前 / 次」の別名として残す（-1 からの操作継続性）。 */
  document.addEventListener('keydown', function(e){
    if (!openFlag) { return; }
    var k = e.key;
    if (k === 'Escape'){ e.preventDefault(); close(); return; }
    var cur = idxFromScroll();
    if (k === 'ArrowDown' || k === 'ArrowRight' || k === 'PageDown' || k === ' ' || k === 'Spacebar'){
      e.preventDefault(); goTo(cur + 1);
    } else if (k === 'ArrowUp' || k === 'ArrowLeft' || k === 'PageUp'){
      e.preventDefault(); goTo(cur - 1);
    } else if (k === 'Home'){
      e.preventDefault(); goTo(0);
    } else if (k === 'End'){
      e.preventDefault(); goTo(N - 1);
    }
  });

  /* ── リサイズ / 画面回転 ─────────────────────────────────────────────────────
     セル高 = スクローラ高なので、寸法が変わると scrollTop の意味も変わる。
     現在のセルを保持したまま新しい寸法のスナップ点へ置き直す。
     ★ 連続発火の合成 ★ 回転中は resize が何度も飛ぶので rAF 1 本にまとめる。 */
  var resizeRaf = null;
  function onResize(){
    if (!openFlag) { return; }
    if (resizeRaf !== null) { return; }
    resizeRaf = requestAnimationFrame(function(){
      resizeRaf = null;
      if (!openFlag) { return; }
      jumpTo(curIdx);
    });
  }
  window.addEventListener('resize', onResize);
  window.addEventListener('orientationchange', onResize);

  /* ルーター（ハッシュ）が動いたら閉じる ＝ 端末の戻るボタンでビューワーから抜けられる（-1 と同一）。 */
  window.addEventListener('hashchange', function(){ close(); });

  /* 検証用の読み取り専用フック（自動回帰・実測用。挙動には一切影響しない）。
     -1 と同じキー名を維持し、世代 -2 で意味が変わったものはコメントで明示する。 */
  window.ASF_LOOK_VIEWER = {
    gen: 2,
    snap: function(){ return !!SNAP; },
    open: function(i){ open(i || 0); },
    close: close,
    isOpen: function(){ return openFlag; },
    index: function(){ return openFlag ? idxFromScroll() : curIdx; },
    count: function(){ var l = getEntries(); return l ? l.length : 0; },
    /* -1 の offset() は「ストリップの steps 単位オフセット」だったが、
       -2 では「セル単位の連続スクロール位置」（3.5 = 4 枚目と 5 枚目の中間）を返す。 */
    offset: function(){ return scroller ? (scroller.scrollTop / cellH()) : 0; },
    busy: function(){ return false; }            /* 自前トゥイーンが無いので常に false */
  };
})();
